// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal.modal--recommendedtournamentsmodal{padding-bottom:0;max-width:736px}.recommended-tournaments-modal__body{margin-top:24px}.recommended-tournaments-modal__text{font-size:18px;color:#cfd8dc}.recommended-tournaments-modal .tournaments-list__body-inner{margin-top:16px}.recommended-tournaments-modal .tournaments-list .tournament-card{background:#232f3f}@media(max-width: 768px){.recommended-tournaments-modal{padding-bottom:24px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
